import Box from '@zenbusiness/zui/Box';
import { superstyled } from '@zenbusiness/zui/styles';

export const SubscriptionAssetContainer = superstyled({
  tag: Box,
  name: 'SubscriptionAsset',
  slot: 'SubscriptionAssetContainer',
  styles: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    alignSelf: 'baseline',
  },
});
